import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-800 text-white py-4">
      <div className="container mx-auto text-center">
        <p className="text-sm mb-2">
          © {currentYear} <a href="https://publyland.es" target="_blank">Publyland M&T</a> {t('app.name')} - {t('footer.rights')}
        </p>
        <div className="flex justify-center space-x-4 text-sm text-gray-400">
          <Link to="/privacy" className="hover:text-white transition-colors">
            {t('navigation.privacy')}
          </Link>
          <Link to="/cookies" className="hover:text-white transition-colors">
            {t('navigation.cookies')}
          </Link>
        </div>
      </div>
    </footer>
  );
}
